import { render } from "./PlatformAdministrationPage.vue?vue&type=template&id=28be405c&scoped=true"
import script from "./PlatformAdministrationPage.vue?vue&type=script&lang=js"
export * from "./PlatformAdministrationPage.vue?vue&type=script&lang=js"

import "./PlatformAdministrationPage.vue?vue&type=style&index=0&id=28be405c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28be405c"]])

export default __exports__